export const contactFormKeys = {
  hero: {
    title: "form:panelTitle",
    subtitle: "form:panelSubtitle",
  },
  fields: {
    fullName: {
      label: "form:labels:fullName",
      placeholder: "form:placeholders:fullName",
      errors: {
        required: "form:errors:required",
        min: "form:errors:fullName:min",
        max: "form:errors:fullName:max",
      },
    },
    email: {
      label: "form:labels:email",
      placeholder: "form:placeholders:email",
      errors: {
        required: "form:errors:required",
        email: "form:errors:email",
      },
    },
    phone: {
      label: "form:labels:phone",
      placeholder: "form:placeholders:phone",
      errors: {
        max: "form:errors:phone:max",
      },
    },
    subject: {
      label: "form:labels:subject",
      placeholder: "form:placeholders:subject",
      errors: {
        required: "form:errors:required",
        min: "form:errors:subject:min",
        max: "form:errors:subject:max",
      },
    },
    message: {
      label: "form:labels:message",
      placeholder: "form:placeholders:message",
      errors: {
        required: "form:errors:required",
        min: "form:errors:message:min",
        max: "form:errors:message:max",
      },
    },
  },
  buttons: {
    submit: "form:buttons:submit",
    submitting: "form:buttons:submitting",
  },
  messages: {
    success: "form:messages:success",
    error: "form:messages:error",
  },
} as const;
